// extracted by mini-css-extract-plugin
export default {"synchronized-inboxes-form-section":"SynchronizedInboxesForm_synchronized-inboxes-form-section__bZMFa"};